import React, { useEffect } from 'react'
import { useLazyQuery, gql, NetworkStatus } from '@apollo/client'
import moment from 'moment'
import CardWidget, { Colors } from '../../../../components/CardWidget'
import CardWidgetSkeleton from '../../../../components/skeletons/CardWidgetSkeleton'
import { formatCurrency } from '../../../../utils/Helpers'
import { STATUS_DELIVERING, STATUS_AVAILABLE, STATUS_CONFIRMED, STATUS_WAITING_CONFIRMATION } from '../../../../types/Order'

const GET_DATA = gql`
  query OpenGMV($initialDate: String, $finalDate: String) {
    ordersAggs (
      size: 0,
      query: {
        bool: {
          filter: [
            {
              range: {
                created_at: {
                  gte: $initialDate,
                  lte: $finalDate,
                  format: "yyyy",
                  time_zone: "-03:00"
                }
              }
            },
            {
              terms: {
                status_translate_keyword: [
                  "${STATUS_WAITING_CONFIRMATION}",
                  "${STATUS_CONFIRMED}",
                  "${STATUS_DELIVERING}",
                  "${STATUS_AVAILABLE}"
                ]
              }
            }
          ]
        }
      },
      aggs: {
        total: {
          sum: {
            field: "total"
          }
        }
      }
    ){
      aggregations
    }
  }
`

const OpenGMV = (): JSX.Element => {
  const [getData, { loading, error, data, networkStatus }] = useLazyQuery(
    GET_DATA, {
      notifyOnNetworkStatusChange: true,
      variables: {
        initialDate: `${moment().clone().format('YYYY')}||/y`,
        finalDate: `${moment().clone().format('YYYY')}||/y`
      }
    }
  )

  useEffect(() => {
    getData()
  }, [])

  if (networkStatus === NetworkStatus.refetch) return <CardWidgetSkeleton />
  if (loading || !data) return <CardWidgetSkeleton />
  if (error) return <p>Error :(</p>

  return (
    <CardWidget title={`GMV em aberto total (dado fixo para o ano ${moment().format('y')})`} number={formatCurrency(data.ordersAggs.aggregations.total.value)} color={Colors.red} />
  )
}

export default OpenGMV
